let Salsa = {
    beginner: [
        
            {
                name: "How To Spin Your Partner",
                link: "46dybRGrCsc"
            },
            {
                name: "Make your basic step look more natural",
                link:  "9CzGaubcqQg"
            },
            {
                name: "Closed position lead setup",
                link: "vWeJbJgkTFQ"
            }
        
        
    ],
    intermediate: [
        {
            name: "Pencil turns",
            link: "ADysVrHMp3g"

        },
        {
            name: "Lady double turn",
            link: "TDoyttBpzU0"
        },    
        {   name: "Underarm turns",
            link: "lhu6spVILW8"        
        }
    ],
    advanced: [
        {
            name: "Back spot turn into cross body lead",
            link: "ln9nxU-xN6A"
        },

        {
            name: "Breakaway turn (inspired by Lindy hop)", 
            link: "ziH6X4QHITY"
        },
        {
            name: "Back spot turn into titanic",
            link: "yPkNaOGyAyc"
        }
    ]
}
let Bachata = {
    beginner: [
    {
        name: "Side basic and forward basic with simple turn",
        link: "tgRMUVD1FeM"
    },
    {
        name: "Beginning Bachata footwork",
        link: "yz8JhAA_foE"
    },
    {
        name: "6 Bachata Basic Steps", 
        link: "TJGfUGUoZe0"
    }
    ],
    intermediate: [
        {
            name: "Alternating turns into slide", 
            link: "j3Fshk1NWyA"
        },

        {
            name: "Syncopation steps by Alemana", 
            link: "Znytk6hMyj4"
        },
        {
            name: "Side to side footwork (kick shuffles)", 
            link: "Lco4bvPyz5A"
        }
    ],
    advanced: [
        {
            name: "More advanced footwork (nice rotational moves with Texas Tommy)",
            link: "5R8bhnseysk"
        },
        {
            name: "Bachata advanced footwork", 
            link: "FVi_SaJPeqA"
        },
        {
            name: "Dips and lunges", 
            link: "Esd3BlxUXdU"
        }
    ]
}
let Merengue = {
    beginner: [
        {
            name: "basic steps",
            link: "KO_hobER7SU"
        },
        {
            name: "Side together side steps",
            link: "OAp3IknZmV8"
        },
        {
            name: "Side to side, turns, basic combinations",
            link: "UDSbJAy6ehQ"
        }

          
    ],
    intermediate: [
        {
            name:"Rainbow separation step",
            link:"emmJJkf2DFo"
        },
        {
            name:"Colocho",
            link:"FJ5MrZsPIjQ" 
        },
        {
            name: "Basket",
            link: "3CxuhGMF6R8"
        }
          
         
    ],
    advanced: [
        {
            name:"Wrap to tunnel",
            link: "4d1u1P36HWk"       
        },
        {
            name:"Hammerlock to behind the back",
            link: "70J6zISofBk"       
        },
        {
            name:"Conga breaks with crossing action",
            link:"SHOOMxiSD-k"        
        }         
    ]
}

export {
    Salsa,
    Bachata,
    Merengue
};